import i18n from "./index";
import {getSavedLanguage, setSavedLanguage} from "../utils/localStorage/localStorage";



/**
 * Use a string value {en, ja, fr, de}
 * @param {string} lng language to change to
 * @returns null
 */
export function changeI18nLanguage(lng) {
    i18n.changeLanguage(lng);
    setSavedLanguage(lng)
}

export function getDefaultI18nLanguage () {
    let lng = getSavedLanguage();
    if (!lng) {
        lng = 'en'
    }

    return lng;
}
